import {
  FaCarSide,
  FaHeadset,
  FaUsers,
  FaTags,
  FaMapMarkerAlt,
  FaSyncAlt,
} from "react-icons/fa";

const features = [
  {
    icon: <FaCarSide className="text-3xl text-white" />,
    title: "Premium Fleet",
    description: "Latest model cars with regular maintenance and safety checks",
  },
  // {
  //   icon: <FaSyncAlt className="text-3xl text-white" />,
  //   title: "Flexible Booking",
  //   description: "Easily modify or cancel your reservation with minimal hassle",
  // },
  
  {
    icon: <FaHeadset className="text-3xl text-white" />,
    title: "24/7 Support",
    description: "Round-the-clock customer support and roadside assistance",
  },
  // {
  //   icon: <FaUsers className="text-3xl text-white" />,
  //   title: "Expert Team",
  //   description: "Professional staff with years of experience in car rental",
  // },
  {
    icon: <FaTags className="text-3xl text-white" />,
    title: "Best Prices",
    description: "Competitive rates with no hidden charges",
  },
  // {
  //   icon: <FaMapMarkerAlt className="text-3xl text-white" />,
  //   title: "Multiple Locations",
  //   description: "Convenient pickup and drop-off on multiple locations",
  // },
];

function WhyChooseUs() {
  return (
    <>
      <div className="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8 ">
        <div className="flex flex-col justify-center items-center text-[#006039] font-semibold">
          <h1
            className="flex items-center justify-center  pt-6 
        relative text-2xl sm:text-3xl md:text-4xl lg:text-4xl text-center text-[#006039] font-semibold inline-block"
          >
            Why Choose Us?
          </h1>
          <p>Explore trending locations around the globe</p>
        </div>

        <div className="px-6 py-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 mx-auto rounded-full bg-[#006039] flex items-center justify-center mb-4 shadow-lg">
                  {feature.icon}
                </div>
                <h3 className="text-lg font-semibold text-[#006039]">
                  {feature.title}
                </h3>
                <p className="text-sm text-gray-600 mt-1">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default WhyChooseUs;
